var CatchmentTerm = {
  ACT: 'priority enrolment area',
  VIC: 'school zone',
  TAS: 'local intake Area',
  WA: 'local intake Area',
  default: 'catchment'
};
var getCatchmentTerm = state => CatchmentTerm[state] || CatchmentTerm.default;
export default getCatchmentTerm;